<ejs-tooltip [position]="placement">
  <ng-template #content>
    <div class="hint-content">
      <ng-container *ngFor="let h of hint.split('\n')"> {{ h }} <br /> </ng-container>
    </div>
  </ng-template>
  <i class="far fa-question-circle text-boulder font-md"></i>
</ejs-tooltip>
